import { Link } from 'react-router-dom';
import { Opportunity, Signal } from '../../../types';
import { formatSignalType } from '../utils/formatters';

interface RecommendedActionProps {
  bestOpportunity: Opportunity;
  signals: Signal[];
}

export default function RecommendedAction({ bestOpportunity, signals }: RecommendedActionProps) {
  // Only render if edge threshold is met
  if (bestOpportunity.adjustedEdge < 0.03) {
    return null;
  }

  return (
    <div className="card bg-gradient-to-r from-purple-900/20 to-blue-900/20 border-purple-500/30">
      <div className="flex items-center gap-3 mb-3">
        <span className="text-2xl">🎯</span>
        <h2 className="text-lg font-semibold">RECOMMENDED ACTION</h2>
      </div>
      <div className="bg-surface-100 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <span
                className={`px-3 py-1 rounded text-lg font-bold ${
                  bestOpportunity.recommendedAction === 'buy_pm'
                    ? 'bg-green-500/20 text-green-400'
                    : 'bg-red-500/20 text-red-400'
                }`}
              >
                {bestOpportunity.recommendedAction === 'buy_pm' ? 'BUY' : 'SELL'}
              </span>
              <span className="text-gray-300">on Polymarket</span>
              <span className="text-purple-400 font-mono font-bold">
                @ ${(bestOpportunity.impliedProbPolymarket).toFixed(2)}
              </span>
            </div>
            <div className="flex items-center gap-4 text-sm">
              <div>
                <span className="text-gray-400">Edge:</span>{' '}
                <span className="text-green-400 font-bold">
                  {(bestOpportunity.adjustedEdge * 100).toFixed(1)}%
                </span>
              </div>
              <div>
                <span className="text-gray-400">Strength:</span>{' '}
                <span className={`font-medium ${
                  bestOpportunity.rlmStrength >= 0.8 ? 'text-green-400' :
                  bestOpportunity.rlmStrength >= 0.6 ? 'text-yellow-400' :
                  'text-gray-400'
                }`}>
                  {bestOpportunity.rlmStrength >= 0.8 ? 'High' :
                   bestOpportunity.rlmStrength >= 0.6 ? 'Medium' : 'Low'}
                </span>
              </div>
              <div>
                <span className="text-gray-400">Signal:</span>{' '}
                <span className="text-blue-400">
                  {signals.length > 0 ? formatSignalType(signals[0].signalType) : 'Multiple'}
                </span>
              </div>
            </div>
          </div>
          <Link
            to="/opportunities"
            className="px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg transition-colors flex items-center gap-2"
          >
            Place Bet →
          </Link>
        </div>
      </div>
    </div>
  );
}
